import React from 'react';
import { Icon } from './Icon.js';
export const IconMediaPauseFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "2", y: "2", width: "5", height: "14", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("rect", { x: "11", y: "2", width: "5", height: "14", rx: "1.75", ry: "1.75", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconMediaPauseFill18.js.map